import styled from 'styled-components';
import { Typography } from '../../../global/theme';
import { FlexCenter, ShowVerticalScrollbar } from '../../../global/commonStyle';

const DescriptionInputSection = styled.div`
  .tiptap {
    max-height: 240px;
    min-height: 90px;
    ${ShowVerticalScrollbar}
  }
`;
const FileBox = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-10);
  margin-block: var(--space-8) var(--space-0);
  padding: var(--space-0);
`;

const DropFileDiv = styled.div`
  position: absolute;
  // top: 0;
  // left: 0;
  margin-top: -10px;
  width: calc(100% - 32px);
  // height: calc(100% - 32px);
  background: var(--background-secondary);
  z-index: var(--z-index-base);
  ${FlexCenter}
  flex-direction: column;
  gap: var(--space-4);
  pointer-events: none;
  border: 1px dashed var(--border-secondary);
  border-radius: var(--border-radius-8);
  padding: var(--space-20) var(--space-16) var(--space-18) var(--space-16);
  span {
    ${Typography.body_md_medium}
    color: var(--text-primary);
  }
`;

export { DescriptionInputSection, FileBox, DropFileDiv };
